export default __webpack_public_path__ + "media/images/receiving-collect-icon-2b3f2857.png";